import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'std-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent implements OnInit {
  @Input() message = 'Placeholder';
  @Input() status = 'success';
  @Input() img = 'null';
  @Input() imgClass = '';
  @Input() customClass: string | undefined;

  constructor() {}

  ngOnInit(): void {}

  closeMessage() {
    this.message = '';
  }
}
